import React, { useEffect, useState } from "react";
import { getImageUrl, formatDate } from "src/Common/common";
import { useNavigate, useParams } from "react-router-dom";
import CustomerService from "src/Services/API/customer.service";
import { setCustomerName } from "src/Redux/Slices/HeaderSlice";
import { useDispatch } from "react-redux";
import BlueButton from "src/Components/Common/bluebutton";
import AdminAddModal from "./adminaddmodal";
import CustomerInviteService from "src/Services/API/customer.invite.service";
import { toast } from "react-toastify";
import CustomerWO from "./WO/CustomerWo";
import CustomerForms from "./WO/CustomerForms";
import AcceptStatus from "src/Pages/Setting/Team/Invite/Status/acceptstatus";
import PendingStatus from "src/Pages/Setting/Team/Invite/Status/pendingstatus";
import TemplateList from "src/Pages/forms/templates/TemplateList";

const CustomerDetail = () => {
  const navigate = useNavigate();
  const { customerId } = useParams();

  const [customer, setCustomer] = useState(null);
  const dispatch = useDispatch();
  const [isAddCustomerAdminModalOpen, setIsAddCustomerAdminModalOpen] = useState(false);

  const [invites, setInvites] = useState([]);

  useEffect(() => {
    console.log("customerId: ", customerId);
    const fetchCustomer = async () => {
      try {
        const response = await CustomerService.getOne(customerId);
        setCustomer(response.data);
        dispatch(setCustomerName(response.data.companyName));
      } catch (error) {
        console.log("Failed to load customer data: ", error);
      }
    };

    if (customerId) {
      fetchCustomer();
      getAllInvites();
    }
  }, [customerId]);

  const getAllInvites = async () => {
    try {
      const response = await CustomerInviteService.getAll(customerId);
      console.log("🚀 ~ fetchInvites ~ response:", response);
      setInvites(response.data);
    } catch (error) {
      console.log("Failed to load customer invites: ", error);
    }
  };

  const addCustomerAdmin = (data) => {
    CustomerInviteService.create(data)
      .then((res) => {
        console.log("Sending Customer Invite: ", res);
        toast.success("Customer Admin Added Successfully");
        getAllInvites();
      })
      .catch((err) => {
        if (err.response.status === 409) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Something went wrong");
          console.log("Sending Customer Invite Failed: ", err);
        }
      })
      .finally(() => {
        setIsAddCustomerAdminModalOpen(false);
      });
  };

  const onCancelClicked = (index) => {
    CustomerInviteService.deleteInvite(invites[index].id)
      .then((response) => {
        getAllInvites();
        toast("Invite cancelled successfully");
      })
      .catch((error) => {
        toast("An error occured");
      });
  };

  const onRepeatClicked = (index) => {
    CustomerInviteService.repeatInvite(invites[index].id)
      .then((response) => {
        toast("Invite has been sent again successfully");
      })
      .catch((error) => {
        toast("An error occured");
      });
  };

  return (
    <div className="w-full h-full px-5 py-3">
      {isAddCustomerAdminModalOpen && (
        <AdminAddModal
          onAddClicked={addCustomerAdmin}
          onCancelClicked={() => {
            setIsAddCustomerAdminModalOpen(false);
          }}
          customer={customer}
        />
      )}
      <div className="w-full h-[56px] flex items-center justify-between ">
        <div className="flex items-center cursor-pointer" onClick={() => navigate(-1)}>
          <img src={getImageUrl("/images/common/back_arrow.png")} className="w-[24px]" />
          <span className="font-OpenSansRegular text-[14px] font-[700] text-subTitleColor">back</span>
        </div>
      </div>
      <div className="w-full border-solid border-[1px] border-borderColor">
        <div className="w-full h-[30px]  flex items-center px-3">
          <span className="font-OpenSansRegular font-[700] text-[16px] text-titleColor ">Customer Information</span>
        </div>
        <div className="w-full h-[50px] border-solid border-t-[1px] border-borderColor flex items-center justify-between px-3">
          <div className="h-[32px] flex flex-col gap-1">
            <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Address</p>
            <p className="font-OpenSansRegular  text-[10px] text-titleColor">{customer && customer.address}</p>
          </div>
          <div className="h-[32px] flex flex-col gap-1">
            <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Phone Number</p>
            <p className="font-OpenSansRegular text-[10px] text-titleColor">{customer && customer.phone}</p>
          </div>
          <div className="h-[32px] flex flex-col gap-1">
            <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Date Added</p>
            <p className="font-OpenSansRegular text-[10px] text-titleColor">
              {customer && formatDate(customer.createdAt)}
            </p>
          </div>
        </div>
      </div>

      <div className="w-full border-solid border-[1px] border-borderColor  mt-3">
        <div className="w-full h-[40px]  flex items-center px-3 justify-between">
          <span className="font-OpenSansRegular font-[700] text-[16px] text-titleColor ">Customer Users</span>
          <BlueButton
            title="ADD CUSTOMER ADMIN"
            onClicked={() => {
              console.log("customer: ", customer);
              if (!customer.branch) {
                toast.error("Please select a branch for this customer first");
                return;
              }
              setIsAddCustomerAdminModalOpen(true);
            }}
          />
        </div>
        <div className="w-full min-h-[80px] flex items-center justify-center">
          <table className="w-full">
            <thead>
              <tr className="border-t-[1px] border-b-[1px] border-borderColor">
                <th className="border-r-[1px] border-borderColor w-[30%]">
                  <div className="font-OpenSansRegular  font-[700] text-[12px] flex items-center px-4 h-[40px] text-titleColor">
                    <span>Email</span>
                  </div>
                </th>
                <th className="border-r-[1px] border-borderColor w-[20%]">
                  <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center pl-4 h-[40px] text-titleColor">
                    Role
                  </div>
                </th>
                <th className="border-r-[1px] border-borderColor w-[25%]">
                  <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center pl-4 h-[40px] text-titleColor">
                    Status
                  </div>
                </th>
                <th className="w-[25%] border-r-[1px] border-borderColor">
                  <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center px-2 h-[40px] text-titleColor">
                    InvitedAt
                  </div>
                </th>
                <th className="w-[100px]">
                  <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center px-2 h-[40px] text-titleColor">
                    ACTION
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {invites.map((invite, i) => (
                <tr key={i} className="border-b-[1px] border-borderColor h-[40px]">
                  <td className="border-r-[1px]  border-borderColor">
                    <div className="font-OpenSansRegular px-[15px] py-[5px] text-[11px] font-[400] col-span-1">
                      {invite.email}
                    </div>
                  </td>
                  <td className="border-r-[1px]  border-borderColor">
                    <div className="font-OpenSansRegular px-[15px] py-[5px] text-[11px] font-[400] col-span-1">
                      {invite.customerRole.name}
                    </div>
                  </td>

                  <td className="border-r-[1px]  border-borderColor">
                    <div className="font-OpenSansRegular px-[15px] py-[5px] text-[11px] font-[400] col-span-1">
                      {invite.accepted ? <AcceptStatus /> : <PendingStatus />}
                    </div>
                  </td>
                  <td className="border-r-[1px]  border-borderColor">
                    <div className="font-OpenSansRegular px-[15px] py-[5px] text-[11px] font-[400] col-span-1">
                      {formatDate(invite.createdAt)}
                    </div>
                  </td>
                  <td>
                    <div className="flex items-center gap-1 justify-center">
                      <img
                        onClick={() => onCancelClicked(i)}
                        src={getImageUrl("/images/customerdetail/trash.png")}
                        className="w-[17px] h-[17px] cursor-pointer"
                      />
                      {/* <img
                        onClick={() => onRepeatClicked(i)}
                        src={getImageUrl("/images/customerdetail/repeat.png")}
                        className="w-[22px] h-[22px] cursor-pointer"
                      /> */}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="w-full border-solid border-[1px] border-borderColor  mt-3">
        <div className="w-full h-[30px]  flex items-center px-3">
          <span className="font-OpenSansRegular font-[700] text-[16px] text-titleColor ">Work Orders</span>
        </div>
        <div className="w-full min-h-[80px] flex items-center justify-center ">
          <CustomerWO customerId={customerId} />
        </div>
      </div>

      <div className="w-full border-solid border-[1px] border-borderColor mt-3">
        <div className="w-full h-[30px] flex items-center px-3">
          <span className="font-OpenSansRegular font-[700] text-[16px] text-titleColor ">Forms</span>
        </div>
        <div className="w-full min-h-[80px]">
          <CustomerForms customerId={customerId} />
        </div>
      </div>

      <div className="w-full border-solid border-[1px] border-borderColor mt-3">
        <div className="w-full h-[30px] flex items-center px-3">
          <span className="font-OpenSansRegular font-[700] text-[16px] text-titleColor ">Templates</span>
        </div>
        <div className="w-full min-h-[80px]">
          <TemplateList hideTabs hideControls customerId={customerId} />
        </div>
      </div>
    </div>
  );
};

export default CustomerDetail;
